import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { SubgrupoShow } from '../../components'
import * as subgrupoActionCreators from '../../redux/modules/subgrupo'

class SubgrupoShowContainer extends Component {

  static propTypes = {
    id: PropTypes.string,
    fetchSubgrupo: PropTypes.func,
    history: PropTypes.object,
    destroySubgrupo: PropTypes.func,
  }

  state = {
    subgrupo: null
  }

  async componentDidMount () {
    if (this.props.id) {
      const subgrupo = await this.props.fetchSubgrupo(this.props.id)
      this.setState({ subgrupo })
    }
  }

  handleRedirectToNew = () => {
    this.props.history.push('/subgrupos/new')
  }

  handleEditResource = (id) => {
    this.props.history.push(`/subgrupos/${id}/edit`)
  }

  handleDeleteResource = async (id) => {
    await this.props.destroySubgrupo(id)
    this.props.history.push('/subgrupos')
  }

  render () {
    return (
      <SubgrupoShow
        onEditResource={this.handleEditResource}
        onDeleteResource={this.handleDeleteResource}
        subgrupo={this.state.subgrupo} />
    )
  }
}

function mapStateToProps ({subgrupo}, {match}) {
  const { id } = match.params
  if (id) {
    return {
      id,
      subgrupo: subgrupo.get('id'),
    }
  }
  return {}
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    ...subgrupoActionCreators
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(SubgrupoShowContainer)
